import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function TeanContentReducer(state = initialState.testContent, action: any) {
  switch (action.type) {
    case types.SAVE_TESTCONTENT_SUCCESS:
      return action.testContent;
    default:
      return state;
  }
}
